import React, { useContext, useState, useEffect } from 'react';
import { EiqTable, EiqCheckbox } from 'eiq-storybook';
import { useTranslation } from 'react-i18next';
import { getFiltering, setFiltering } from 'src/utils/data/filtering';
import { useQueryParams, useSetQueryParams } from 'src/hooks/utils';
import { setSorting } from 'src/utils/data/sorting';
import CurrentUserMetaContext from 'src/utils/context/CurrentUserMetaContext';
import CurrentUserMetaReloadContext from 'src/utils/context/CurrentUserMetaReloadContext';
import { isColumnHidden } from 'src/utils/form/dataGrid';
import { EDIT_USER_META_MUTATION } from 'src/graphql/currentUserMeta/mutation';
import client from 'src/utils/api/client';
import { TableMetaProvider } from 'src/utils/context/TableMetaContext';
import { getShowDeleted, setShowDeleted } from 'src/utils/data/deleted';
import { TableDefaultProps, TablePropTypes } from './propTypes';
import s from './Base';

const Table = ({
  data,
  gridColumns,
  loading,
  totalCount,
  name,
  onPageChanged,
  refetch: refetchReal,
  title,
  variables,
  order,
  header,
  hideDeletedButton,
  hideColumnFilter = false,
  currentPageNo = 0,
  paginationUseQuery = true,
  showColumnSettings = true,
  showPagination = true,
  ...rest
}) => {
  const { t } = useTranslation();
  const currentUserMetaReload = useContext(CurrentUserMetaReloadContext);
  let currentUserMeta = null;
  if (header || name === 'JobsGrid') {
    currentUserMeta = useContext(CurrentUserMetaContext)[name];
  }
  const [refetchVariables, setRefetchVariables] = useState(variables);
  const { page = 1, limit = 15 } = paginationUseQuery && useQueryParams(window.location);
  const [currentPageIndex, setCurrentPageIndex] = useState(page - 1);
  const [pageSize, setCurrentPageSize] = useState(+limit);
  const [columns, setColumns] = useState(gridColumns);
  const sortColumnVariable = [
    {
      id: variables?.orderBy,
      desc: variables?.orderDirection === 'desc',
    },
  ];
  const customSortingVariable = {
    id: variables?.orderBy,
    desc: variables?.orderDirection === 'desc',
  }

  const [sortColumn, setCurrentSortColumn] = useState(sortColumnVariable);
  const [customSorting, setCustomSorting] = useState(customSortingVariable);
  useEffect(() => {
    setCurrentPageSize(+limit);
  }, [limit]);
  useEffect(() => {
    setCurrentSortColumn([
      {
        id: refetchVariables?.orderBy,
        desc: refetchVariables?.orderDirection === 'desc',
      },
    ])
    setCustomSorting({
      id: refetchVariables?.orderBy,
      desc: refetchVariables?.orderDirection === 'desc',
    })
   
    if(refetchReal) refetchReal(refetchVariables);
  }, [JSON.stringify(refetchVariables)]);

  useEffect(() => {
    const newData = [];

    gridColumns.forEach((item, index) => {
      const obj = item;
      obj.show = !isColumnHidden(currentUserMeta, index);
      newData.push(obj);
    });
    setColumns(newData);
  }, [currentUserMeta, gridColumns]);

  useEffect(() => {
 
  }, [currentPageNo]);

  const refetch = async (vars = {}) => {
    const filtering = getFiltering(name);
    let columnFilters = [];
    if (filtering.length > 0) {
      columnFilters = filtering.map(({ field, value, column }) => {
        return ({
        field,
        value: !column && ['roles', 'timezone_id'].includes(field) ? JSON.stringify(value.ids) : JSON.stringify(value),
      })});
    }
    const newVars = {
      ...refetchVariables,
      ...vars,
      columnFilters
    };
    setRefetchVariables(newVars);
  };
  const forceRefetch = () => {
    onPageChanged(currentPageIndex, pageSize);
    if(refetchReal) refetchReal(refetchVariables);
  };

  const [filters, setFiltersReal] = useState(() => {
    const filtering = getFiltering(name);
    return filtering;
  });

  const [filtersVisible, setFiltersVisible] = useState(filters.length > 0);

  const setFilters = newFilters => {
    setFiltersReal(newFilters);
    if(paginationUseQuery) useSetQueryParams(window.location, { page: 1 });

    setFiltering(name, newFilters);
    setFiltersVisible(newFilters.length > 0);
  };

  const onSortedChange = sortData => {
    const orderColumn = sortData[0].id;
    const direction = sortData[0].desc === true ? 'desc' : 'asc';
    if(paginationUseQuery) useSetQueryParams(window.location, { page: 1 });
    const orderData = {
      orderBy: orderColumn,
      orderDirection: direction,
      offset: 0,
      limit: pageSize,
    };
    setCurrentPageIndex(0);
    refetch(orderData);
    setSorting(name, orderData);
  };
  const preparedData = prepareddata => {
    let result = 0;
    const columnsData = Object.keys(prepareddata);
    columnsData.forEach((item, index) => {
      const checked = prepareddata[item];
      if (checked) {
        // eslint-disable-next-line no-bitwise
        result |= 1 << index;
      }
    });

    if (result === 0) {
      result = 1;
    }
    return result;
  };
  const onColumnSaveSettings = savedata => {
    client
      .mutate({
        mutation: EDIT_USER_META_MUTATION,
        variables: {
          key: name,
          value: preparedData(savedata).toString(),
        },
      })
      .then(() => {
        currentUserMetaReload();
      });
  };
  const gotoPage = (pageNo, limitSize) => {
    const toPageSize = !limitSize ? pageSize : limitSize;
    setCurrentPageIndex(pageNo);
    if (paginationUseQuery) {
      useSetQueryParams(window.location, {
        page: pageNo + 1,
        limit: toPageSize,
      });
    }
    refetch({
      offset: pageNo * toPageSize,
      limit: toPageSize,
    });
  };

  useEffect(() => {
    gotoPage(page - 1);
  }, [page]);

  useEffect(() => {
    if (+limit !== pageSize)
      gotoPage(0, pageSize);
  }, [pageSize]);
  
  const [withDeleted, setWithDeletedReal] = useState(
    getShowDeleted(name) || false,
  );

  const setWithDeleted = newValue => {    
    gotoPage(0, pageSize);
    setWithDeletedReal(newValue);
    setShowDeleted(name, newValue);
  };
  useEffect(() => {
    refetch({ withDeleted });
  }, [withDeleted]);
  let headerEl = null;
  if (header) {
    headerEl = header();
  }

  return (
    <TableMetaProvider
      value={{
        // filters,
        // filtersVisible,
        // setFilters,
        // setFiltersVisible,
        gridColumns,
        filters,
        filtersVisible,
        forceRefetch,
        meta: currentUserMeta,
        name,
        refetch,
        variables,
        hideDeletedButton,
        withDeleted,
        setWithDeleted,
        setColumns,
        setFilters,
        setFiltersVisible,
      }}
    >
      <s.TableContainer className={"mainTable"}>
        <s.HeaderBlock>
          {!hideDeletedButton && (
            <s.DeletedBlock
              selected={withDeleted}
            >
              <EiqCheckbox label={t('SHOW_DELETED_ROWS')} onChange={() => setWithDeleted(!withDeleted)} checked={withDeleted} disabled={loading}/>
            </s.DeletedBlock>
          )}
          {headerEl}
        </s.HeaderBlock>
        <EiqTable
          className="assessTable"
          columns={columns}
          data={!loading ? ( data ?? []) : []}
          loading={loading}
          manualPagination={true}
          showPagination={showPagination}
          sortColumn={sortColumn}
          customSorting={customSorting}
          onSortedChange={onSortedChange}
          onSaveColumnSettings={onColumnSaveSettings}
          showColumnSettings={showColumnSettings}
          pagination={{
            canNextPage: true,
            canPreviousPage: true,
            dataCount: totalCount,
            pageSize,
            pageIndex: currentPageIndex,
            options: [
              { value: 15, label: '15' },
              { value: 30, label: '30' },
              { value: 50, label: '50' },
              { value: 100, label: '100' },
            ],
            gotoPage: pageNo => {
              gotoPage(pageNo);
            },
            nextPage: pageNo => {
              gotoPage(pageNo);
            },
            previousPage: pageNo => {
              gotoPage(pageNo);
            },
            setPageSize: size => {
              setCurrentPageSize(size);
              // gotoPage(0, size);
            },
          }}
        />
      </s.TableContainer>
    </TableMetaProvider>
  );
};

/* Table.propTypes = TablePropTypes;
Table.defaultProps = TableDefaultProps; */

export default React.memo(Table);
